<template>
	<div>
		<list-renderer :apiUrl="'/api/' + $selectedSite.slug + '/providertype/fetchtabdata/' + providerTypeId" :filterIn="['name','slug']" :listInData="'allProviders'" :orderBy="orderBy" :orderByRules="orderByRules">
			<template #header="{title}">
				<h2>{{ title }}</h2>
				<div class="ml-auto">
					<a @click.prevent="showModal" class="btn btn-md btn-success"><i class="fas fa-plus" v-show="userRoles.includes('providers.create')"></i> New Provider</a>
				</div>
			</template>
			<template #content='{list,rawData}'>
				<div class="table-responsive">
					<table>
						<thead>
							<tr>
								<th>Provider Name</th>
								<th>Slug</th>
								<th>Score</th>
								<th>Calc. Score</th>
								<th>Actions</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="provider in list">
								<td>
									{{ provider.name }}
									<span class="badge badge-warning" title="Pending change requests" v-if="rawData.pendingRequests.hasOwnProperty(provider.id)">{{rawData.pendingRequests[provider.id]}}</span>
									<div class="article-links">
										<a :href="'/' + selectedSite.slug + '/providers/' + provider.id + '/edit?tab=properties'" v-show="userRoles.includes('providers.update')">Edit Properties</a>
										<a :href="'/' + selectedSite.slug + '/providers/' + provider.id + '/review?tab=content'" v-show="userRoles.includes('providers.edit-review') && provider.has_review">Edit Review</a>
									</div>
								</td>
								<td>{{ provider.slug }}</td>
								<td>{{ provider.score }}</td>
								<td>{{ provider.ranked_score }}</td>
								<td class="nowrap">
									<a :href="'/' + selectedSite.slug + '/providers/' + provider.id + '/edit?tab=general'" class="btn btn-icon btn-primary" title="Edit" v-show="userRoles.includes('providers.update')"><i class="fas fa-pencil-alt"></i></a>
									<a class="btn btn-icon btn-danger" href="#" title="Delete" v-show="userRoles.includes('providers.update')" @click.prevent="deleteProvider(provider.id)"><i class="fas fa-trash-alt"></i></a>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</template>
		</list-renderer>


		<modal @close="closeModal" v-show="isModalVisible">
			<template slot="header">
				<h4 class="modal-title">New Provider</h4>
			</template>
			<template slot="body">
				<div class="card-body">
					<div class="form-group">
						<label for="name">Name</label>
						<input id="name" name="name" type="text" @keyup="generateSlug" v-model="provider.name">
						<p class="input-error" v-if="errors.errors.name">{{ errors.errors.name }}</p>
					</div>
					<div class="form-group">
						<label for="slug">Slug</label>
						<input id="slug" name="slug" type="text" v-model="provider.slug">
						<p class="input-error" v-if="errors.errors.slug">{{ errors.errors.slug }}</p>
					</div>
					<div class="form-group">
						<label for="score">Score</label>
						<input id="score" name="score" type="number" min="0" max="10" step=".1" v-model="provider.score">
						<p class="input-error" v-if="errors.errors.score">{{ errors.errors.score }}</p>
					</div>
				</div>
			</template>
			<template slot="footer">
				<a @click="closeModal" aria-label="Close modal" class="btn btn-md btn-primary modal-close" href="#"><i class="fas fa-times"></i> Cancel</a>
				<a class="btn btn-md btn-success" href="#" @click.prevent="createProvider"><i class="fas fa-plus"></i> Add Provider</a>
			</template>
		</modal>
	</div>
</template>

<script>
	import modal from '../../Modal/DefaultModal.vue';
	import Errors from '../../../Utils/Errors.js';
	import Slug from '../../../Utils/Slug'

	export default {
		components: {
			modal
		},
		props: {
			dataProviderTypeId: {
				type: Number
			}
		},
		data() {
			return {
				providerTypeId: this.dataProviderTypeId,

				selectedSite: this.$selectedSite,
				userRoles: this.$currentUserRoles,
				isModalVisible: false,
				provider: {
					name: null,
					slug: null,
					score: null,
					provider_type_id: this.dataProviderTypeId,
					has_review: false
				},
				slug: new Slug(),
				errors: new Errors(),

				orderBy: ['pendingRequests', 'name'],
				orderByRules: ['desc', 'asc'],
			}
		},
		methods: {
			showModal: function () {
				this.isModalVisible = true;
			},
			closeModal: function () {
				this.isModalVisible = false;
				this.provider = {
					name: null,
					slug: null,
					score: null,
					provider_type_id: this.dataProviderType.id,
					has_review: false
				};
				this.errors.errors = {};
			},
			generateSlug: function () {
				var slugName = this.provider.name.split(' ').join('');
				this.provider.slug = this.slug.refreshSlug(slugName);
			},
			createProvider: function () {
				axios.post('/api/' + this.$selectedSite.slug + '/providers/', this.provider)
						.then(response => {
							this.$toastr.success('Provider added successfully.');
							window.location.reload();
						})
						.catch(e => {
							this.errors.record(e.response.data);
							this.$toastr.error('Save new Provider failed.', 'Error');
						});
			},
			deleteProvider: function (providerId) {
				this.$dialog.confirm('Are you sure you want to delete this Provider?', {
					loader: true
				})
						.then((dialog) => {
							axios.delete('/api/' + this.$selectedSite.slug + '/providers/' + providerId)
									.then(response => {
										this.$toastr.success('Provider deleted successfully.');
										window.location.reload();
									})
									.catch(e => {
										this.errors.record(e.response.data);
										this.$toastr.error('Provider delete failed.', 'Error');
									});
						})
						.catch(() => {
							this.$toastr.error('Delete aborted.');
						});
			}
		}
	}
</script>

<style scoped>

</style>
